// A lazily loaded chunk can fail to load: a dropped connection, or a deploy mid-upload. The browser
// then keeps the failure until the page reloads, so every later try fails too. Vite fires
// vite:preloadError for any failed dynamic import, SvelteKit's route chunks included: reload once.

const KEY = "preloadErrorReloadAt";
/** A failure this soon after a reload is reported instead, so a chunk that's really gone can't loop. */
const RELOAD_WINDOW_MS = 10_000;

export function reloadOnPreloadError(reload = () => location.reload()) {
  window.addEventListener("vite:preloadError", (event) => {
    try {
      const last = Number(sessionStorage.getItem(KEY));
      if (Date.now() - last < RELOAD_WINDOW_MS) return;
      sessionStorage.setItem(KEY, String(Date.now()));
    } catch {
      return; // Without storage there's no loop guard; let the error through.
    }
    event.preventDefault();
    reload();
  });
}
